import { MODERATION_NOTIFICATIONS } from '../av-moderation/constants';
import { getRoomName } from '../base/conference/functions';
import { toState } from '../base/redux/functions';
/**
 * Tells whether or not the notifications are enabled and if there are any
 * notifications to be displayed based on the current Redux state.
 *
 * @param {IStateful} stateful - The redux store state.
 * @returns {boolean}
 */
export function areThereNotifications(stateful) {
    const state = toState(stateful);
    const { enabled, notifications } = state['features/notifications'];
    return enabled && notifications.length > 0;
}
/**
 * Tells whether join/leave notifications are enabled in interface_config.
 *
 * Generic-Jitsi join noise is suppressed globally via interface_config, EXCEPT
 * in real VRS rooms: a deaf client has no auditory evidence of who is present
 * on the call, so join/leave toasts stay available there regardless of the
 * global default.
 *
 * @param {IStateful} stateful - Optional redux stateful for the room check.
 * @returns {boolean}
 */
export function joinLeaveNotificationsDisabled(stateful) {
    if (stateful !== undefined) {
        const roomName = getRoomName(toState(stateful));
        if (typeof roomName === 'string' && roomName.startsWith('vrs-')) {
            return false;
        }
    }
    if (typeof interfaceConfig === 'undefined') {
        return true;
    }
    return interfaceConfig?.DISABLE_JOIN_LEAVE_NOTIFICATIONS !== false;
}
/**
 * Returns whether or not the moderation notification for the given type is displayed.
 *
 * @param {MEDIA_TYPE} mediaType - The media type to check.
 * @param {IStateful} stateful - The redux store state.
 * @returns {boolean}
 */
export function isModerationNotificationDisplayed(mediaType, stateful) {
    const state = toState(stateful);
    const { notifications } = state['features/notifications'];
    return Boolean(notifications.find(n => n.uid === MODERATION_NOTIFICATIONS[mediaType]));
}
